import React from "react";

export const UnloadsUniversityOld = () => {


return (<></>);
}